<template>
  <div class="container">
    <custom-select
      label="Tipo de Identificacion"
      name="tipoCuil"
      :value="value"
      @input="onChange"
      :items="tiposCuil"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import CustomSelect from "@/components/core/custom/CustomSelect";
import { tipoCuil as _tipoCuil } from "@/config/constants";
import find from "lodash/find";
import get from "lodash/get";

export default {
  name: "CuilType",
  components: { CustomSelect },
  props: {
    value: String,
    situacionLaboral: String,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tiposCuil: []
    };
  },
  //Observa si se realizo un cambio en la situacion laboral
  watch: {
    situacionLaboral: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getTiposCuil(newVal);
      }
    }
  },
  //A la hora de montar el componenete consulta si hay una situacion laboral y llama a la funcion getTiposCuil
  mounted() {
    if (this.situacionLaboral) {
      this.getTiposCuil(this.situacionLaboral);
    }
  },
  methods: {
    //Metodo para traer los tipos de cuil segun la situacion laboral
    getTiposCuil(situacionLaboral) {
      this.tiposCuil = [];
      // Tengo que filtrarlas por Situacion situacionLaboral
      _tipoCuil.forEach(val => {
        if (val.situacionLaboral.indexOf(situacionLaboral) >= 0) {
          this.tiposCuil.push(val);
        }
      });
      //Busca el valor por defecto
      let defaultValue = get(
        find(this.tiposCuil, { value: this.value }),
        "value",
        this.tiposCuil[0].value
      );
      this.$emit("input", defaultValue);
    },
    onChange(val) {
      this.$emit("input", val);
    }
  }
};
</script>
